import UnsubscribeForm from ".";

export default function UnsubscribeFormExamples() {
  return <UnsubscribeForm onFormSubmit={() => {}} />;
}
